// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as _ from 'lodash';
import { SearchResult } from './searchResult';
import { changeResultsLength, prevPage, nextPage, jumpToPage } from './actions/app-actions';

export interface ISearchResultsProps {
    iTotalDisplayRecords: number,
    iDisplayStart: number,
    iDisplayLength: number,
    aaData: Array<Array<string>>,
    onChange: Function,
    dispatch: any,
    isLoading: boolean,
    query: string,
    path: string,
    currentCountry: string
}

interface ISearchResultsState {
    currentPage: number
}

export class SearchResultList extends React.Component<ISearchResultsProps, ISearchResultsState> {
    constructor(props) {
        super(props);
        this.state = { currentPage: (this.props.iDisplayStart / this.props.iDisplayLength) };
    }
    render() {
        return (
            <section className="results-container">
                <article className="results-products">
                    {this.props.iTotalDisplayRecords > 0 ?
                        <nav className="results-products-options">
                            <div className="results-products-options-indicator">
                                Showing {this.props.iDisplayStart + 1} - {(this.props.iDisplayStart + this.props.iDisplayLength) > this.props.iTotalDisplayRecords ? this.props.iTotalDisplayRecords : (this.props.iDisplayStart + this.props.iDisplayLength)} of {this.props.iTotalDisplayRecords}
                            </div>
                            <div className="results-products-options-perpage">
                                Per page <select onChange={this._changeDisplayLength.bind(this)} value={this.props.iDisplayLength} > <option value='10'>10</option> <option value='25'>25</option> <option value='50'>50</option></select>
                            </div>
                            <div className="results-products-options-pagination">
                                <ul>
                                    <li><a href="" onClick={this._prevPage.bind(this)}><svg className="ea-svg-icon icon-double-arrows-left" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-double-arrows-left" />' }}></svg></a></li>
                                    {this._getPageLinks(this._getPageNumbersToDisplay()).map((page) => page)}
                                    <li><a href="" onClick={this._nextPage.bind(this)}><svg className="ea-svg-icon icon-double-arrows-right" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-double-arrows-right" />' }}></svg></a></li>
                                </ul>
                            </div>
                        </nav>
                        : <div></div>
                    }
                    {this.props.iTotalDisplayRecords > 0 ?
                        <div className="results-products-header">
                            <h2>Top Results</h2>
                        </div>
                        :
                        <div></div>
                    }
                    {this.props.isLoading ?
                        <div className="results-loader">LOADING</div>
                        :
                        this.props.iTotalDisplayRecords > 0 ?
                            <section className="results-products-listing">
                                {this.props.aaData.map((result, i) => <SearchResult key={i} rowNum={i} result={result} query={this.props.query} path={this.props.path} country={this.props.currentCountry} />)}
                            </section>
                            :
                            this._getNoResultsContent()
                    }
                    {this.props.iTotalDisplayRecords > 0 ?
                        <div className="results-products-options-footer">
                            <div className="results-products-options-indicator">
                                Showing {this.props.iDisplayStart + 1} - {(this.props.iDisplayStart + this.props.iDisplayLength) > this.props.iTotalDisplayRecords ? this.props.iTotalDisplayRecords : (this.props.iDisplayStart + this.props.iDisplayLength)} of {this.props.iTotalDisplayRecords}
                            </div>
                            <div className="results-products-options-pagination">
                                <ul>
                                    <li><a href="" onClick={this._prevPage.bind(this)}><svg className="ea-svg-icon icon-double-arrows-left" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-double-arrows-left" />' }}></svg></a></li>
                                    {this._getPageLinks(this._getPageNumbersToDisplay()).map((page) => page)}
                                    <li><a href="" onClick={this._nextPage.bind(this)}><svg className="ea-svg-icon icon-double-arrows-right" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-double-arrows-right" />' }}></svg></a></li>
                                </ul>
                            </div>
                        </div>
                        :
                        <div></div>
                    }
                </article>
            </section>
        );
    }

    componentWillReceiveProps(nextProps: ISearchResultsProps) {
        if (nextProps.iDisplayLength != this.props.iDisplayLength) {
            this.setState({ currentPage: (nextProps.iDisplayStart / nextProps.iDisplayLength) });
            if (typeof (this.props.onChange) === 'function') {
                this.props.onChange();
            }
        }
        if (nextProps.iDisplayStart != this.props.iDisplayStart) {
            this.setState({ currentPage: (nextProps.iDisplayStart / nextProps.iDisplayLength) });
        }
    }

    _changeDisplayLength(event) {
        this.props.dispatch(changeResultsLength(event.target.value, Math.floor(this.props.iDisplayStart / event.target.value) * event.target.value));
    }

    _prevPage(event) {
        event.preventDefault();
        this.setState({ currentPage: this.state.currentPage - 1 });
        if (this.props.iDisplayStart == 0)
            return;
        this.props.dispatch(prevPage());
        if (typeof (this.props.onChange) === 'function') {
            this.props.onChange();
        }
    }

    _nextPage(event) {
        event.preventDefault();
        this.setState({ currentPage: this.state.currentPage + 1 });
        if (this.props.iDisplayStart + this.props.iDisplayLength >= this.props.iTotalDisplayRecords)
            return;
        this.props.dispatch(nextPage());
        if (typeof (this.props.onChange) === 'function') {
            this.props.onChange();
        }
    }

    _jumpToPage(page, event) {
        event.preventDefault();
        this.setState({ currentPage: page });
        this.props.dispatch(jumpToPage(page))
        if (typeof (this.props.onChange) === 'function') {
            this.props.onChange();
        }
    }

    _getPageLinks(pageNumbers: number[]) {
        let result = [];
        pageNumbers.forEach((pageNum, i) => {
            if (i != 0) {
                if (pageNumbers[i - 1] != (pageNumbers[i] - 1)) {
                    result.push(<li className="ellipsis" key={-i}>...</li>)
                }
            }
            result.push(
                <li key={i}>
                    <a href="" onClick={this._jumpToPage.bind(this, pageNum)} className={this.state.currentPage === pageNum ? 'active' : ''}>
                        {pageNum + 1}
                    </a>
                </li>);
        });
        return result;
    }

    _getPageNumbersToDisplay() {
        let numPages = Math.ceil(this.props.iTotalDisplayRecords / this.props.iDisplayLength);
        let pages = [];
        _.times(numPages, (i) => {
            if (this.state.currentPage < 3) {
                if (i <= 3)
                    pages.push(i);
                else if (i == (numPages - 1))
                    pages.push(i);
            }
            else if (this.state.currentPage > (numPages - 4)) {
                if (i >= (numPages - 4))
                    pages.push(i);
                else if (i == 0)
                    pages.push(i);
            }
            else {
                if (i == 0 || i == (numPages - 1) || Math.abs(this.state.currentPage - i) <= 1)
                    pages.push(i);
            }
        })
        return pages;
    }

    _getNoResultsContent() {
        let term = this.props.query;
        if (term !== null) {
            term = term.replace(/\\/g, '');
        }
        return (
            <section className="results-products-no-results-content">
                <div className="col-xs-12 col-sm-12 col-md-7 col-lg-8 no-results-col-1">
                    <p className="no-results-msg">No results were found for "{term}"</p>
                    <div className="ea-search-tips">
                        <h3 className="tips-header">Search Tips</h3>
                        <ul>
                            <li>Try searching by product type, manufacturer, or part number</li>
                            <li>Check your spelling</li>
                            <li>Use fewer or more general words</li>
                            <li>Try different keywords</li>
                        </ul>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 no-results-col-2">
                    <div className="register-block-items">
                        {this._getChatOption()}
                        {this._getPhoneOption()}
                        {this._getEmailOption()}
                    </div>
                </div>
            </section>
        )
    }

    _getChatOption() {
        if (this.props.currentCountry === "USA") {
            return (
                <div className="icon-list-item-block">
                    <div>
                        <a href="#" className="icon-circle livechat-icon">
                        </a>
                    </div>
                    <div className="inner-content rich-text">
                        <h5 className="item-title h5-alt"><a href="#">Live Chat</a></h5>
                        <div className="item-description">
                            <p><span>Speak with one of our Technical Service Personnel.</span>
                            </p>
                        </div>
                    </div>
                </div>
            )
        }
        return <div></div>
    }

    _getPhoneOption() {
        let phoneNumber;
        let phoneNumberHref;
        if (this.props.currentCountry === "USA") {
            phoneNumber = "1 (877) 454-9224";
            phoneNumberHref = "18774549224";
        }
        if (this.props.currentCountry === "CAN") {
            phoneNumber = "(888) 458-0554";
            phoneNumberHref = "8884580554";
        }
        return (
            <div className="icon-list-item-block">
                <div>
                    <a href={'tel:' + phoneNumberHref} className="icon-circle phonecall-icon">
                    </a>
                </div>
                <div className="inner-content rich-text">
                    <h5 className="item-title h5-alt"><a href={'tel:' + phoneNumberHref}>Call Us</a></h5>
                    <div className="item-description">
                        <p><span>Contact Customer Service</span><br />
                            <span>{phoneNumber}</span>
                        </p>
                    </div>
                </div>
            </div>
        )
    }

    _getEmailOption() {
        let email;
        if (this.props.currentCountry === "USA") {
            email = "webcus@ellsworth.com";
        }
        if (this.props.currentCountry === "CAN") {
            email = "cawebcus@ellsworth.com";
        }
        return (
            <div className="icon-list-item-block">
                <div>
                    <a href={'mailto:' + email} className="icon-circle email-icon">
                    </a>
                </div>
                <div className="inner-content rich-text">
                    <h5 className="item-title h5-alt"><a href={'mailto:' + email}>Send an Email</a></h5>
                    <div className="item-description">
                        <p><span>We'll respond within 1-2 business days</span>
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}
